export type { ExcelSheetData } from 'screens/business/budgets/budget/lines/importStructure/utils/types';

export interface MappingFieldOption {
    value: string;
    label: string;
}

export const FAMILY_IMPORT_FIELDS: MappingFieldOption[] = [
    { value: 'family', label: 'Família' },
    { value: 'subFamily', label: 'Subfamília' },
];

export interface FamilyColumnMappingEntry {
    excelColumnIndex: number;
    excelColumnName: string;
    mappedField: string | null;
}
